import { render, staticRenderFns } from "./Point.vue?vue&type=template&id=3066b5d1&"
import script from "../../models/analysis/point.ts?vue&type=script&lang=ts&"
export * from "../../models/analysis/point.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports